// extracted by mini-css-extract-plugin
export var blueBackground = "CTAPanel-module--blue-background--d16da";
export var content = "CTAPanel-module--content--6590d";
export var greenBackground = "CTAPanel-module--green-background--936be";
export var greyBackground = "CTAPanel-module--grey-background--e7157";
export var image = "CTAPanel-module--image--1677f";
export var lightGreyBackground = "CTAPanel-module--lightGrey-background--75b1d";
export var lightblueBackground = "CTAPanel-module--lightblue-background--93d1a";
export var orangeBackground = "CTAPanel-module--orange-background--503dc";
export var panel = "CTAPanel-module--panel--5bbbe";
export var visual = "CTAPanel-module--visual--11f14";
export var whiteBackground = "CTAPanel-module--white-background--8a6b2";